import { GetFeatureStatusResponse, useGetFeatureStatusQuery } from "api/portal";
import { ApiError } from "api/shared";
import { ResponseValues } from "axios-hooks";
import React, { createContext, useContext } from "react";

const featureNames = [
  "PortalUI.ProductPagesEnabled",
  "PublicApi.UseAssessAccountCategoriesEndpoints",
  "Assess.UseAssessReportUI",
  "PublicApi.UseAssessGetExcelDownload",
  "PortalUI.DataTypeSettings.ShowContinuousPull",
  "Assess.V2CategoriesExtension",
  "PortalUI.OnboardingMandatory",
  "PortalUI.NewOnboardingFlow",
  "PortalUI.HideStartUpPlan",
  "Rules.UseNewWebhooks",
  "Link.UseNewLinkFlow",
  "PortalUI.ShowSpendInsightsTable",
  "PortalUI.UserTrackingEnabled",
  "PublicApi.EnhancedCashFlow.UseIPF",
] as const;

export type FeatureSwitchName = (typeof featureNames)[number];

interface FeatureStatusContextType
  extends Pick<
    ResponseValues<GetFeatureStatusResponse, null, ApiError>,
    "error" | "loading"
  > {
  featureStatus?: GetFeatureStatusResponse;
}

export const FeatureStatusContext = createContext<FeatureStatusContextType>(
  {} as FeatureStatusContextType
);

export const FeatureStatusContextProvider = ({
  children,
}: React.PropsWithChildren) => {
  const [{ data: featureStatus, error, loading }] = useGetFeatureStatusQuery({
    featureNames,
  });

  return (
    <FeatureStatusContext.Provider
      value={{
        featureStatus,
        error,
        loading,
      }}
    >
      {children}
    </FeatureStatusContext.Provider>
  );
};

export const useFeatureStatus = (): FeatureStatusContextType =>
  useContext(FeatureStatusContext);
